module.exports = __webpack_public_path__ + "static/img/08_wld.099100a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessPlatform/swiperImg/secondLine/08_wld.png
// module id = Zh93
// module chunks = 0